import * as Styled from "./CatalogItemsFiltersForm.styled"

export function CatalogItemsFiltersFormSkeleton() {

    return <Styled.Skeleton />
}